import type { Example } from '../types';

export const cameraPipExample: Example = {
  id: 'camera-pip',
  title: 'Picture-in-Picture Cameras',
  categoryId: 'viewer',
  description: 'Multiple simultaneous viewports defined in SCAD code',
  scadCode: `/* Picture-in-Picture Cameras */

// markdown:tip
// **Picture-in-Picture Cameras** — Use \`camera_pip()\` to define extra
// viewports in your SCAD code. Each PiP can be dragged and resized in the
// viewer. **Click any PiP** to animate the main camera to that position.

/* [Assembly] */

// Base size
base = 50; // [20:1:80]

// Tower height
tower_h = 70; // [20:1:120]

// Arm length
arm = 40; // [10:1:70]

// Color
// color
part_color = [0.25, 0.45, 0.75];

// --- parameters end ---

color(part_color) {
  // Base plate
  cube([base, base, 8], center=true);

  // Vertical tower
  translate([0, 0, 8/2 + tower_h/2])
    cylinder(d=14, h=tower_h, center=true, $fn=32);

  // Horizontal arm
  translate([arm/2, 0, 8/2 + tower_h - 7])
    cube([arm, 10, 10], center=true);

  // End cap sphere
  translate([arm, 0, 8/2 + tower_h - 7])
    sphere(r=8, $fn=32);
}

// ── PiP Cameras ───────────────────────────────────────────────────────────

// Front view — grayscale, bottom-left
camera_pip(
  position=[0, -180, 40],
  target=[0, 0, 40],
  fov=30,
  x=0.01, y=0.01,
  width=0.22, height=0.18,
  title="Front",
  mode="grayscale",
  transitions="zoom_out",
  zoom_out_factor=1.8,
  duration=1.5
);

// Top-down view — bottom-right
camera_pip(
  position=[0, 0, 200],
  target=[0, 0, 40],
  fov=28,
  x=-0.24, y=0.01,
  width=0.22, height=0.18,
  title="Top",
  transitions="orbit,zoom_out",
  orbit_turns=0.5,
  zoom_out_factor=1.5,
  duration=2.0
);

// Close-up on end cap — top-right
camera_pip(
  position=[arm + 30, -30, 8/2 + tower_h + 10],
  target=[arm, 0, 8/2 + tower_h - 7],
  fov=35,
  x=-0.24, y=-0.21,
  width=0.22, height=0.18,
  title="Detail",
  transitions="arc,bounce",
  arc_height=30,
  bounce_amplitude=0.2,
  duration=1.8
);
`,
};
